import { useEffect, useState } from "react";

/**
 * Si la query se queda mucho en pending (p. ej. red o Supabase lento),
 * evita el skeleton infinito y permite mostrar un mensaje amable.
 */
export function useSlowLoadingFallback(isPending: boolean, isError: boolean, ms = 7000) {
  const [slow, setSlow] = useState(false);

  useEffect(() => {
    if (!isPending || isError) {
      setSlow(false);
      return;
    }
    const id = window.setTimeout(() => setSlow(true), ms);
    return () => window.clearTimeout(id);
  }, [isPending, isError, ms]);

  return slow;
}
